import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Partner } from "../components/Partner";
import { Offer } from "../components/Offer";
import AOS from "aos";
import "aos/dist/aos.css";

export const Services = () => {

useEffect(() => {
    AOS.init({
        duration: 1500,
        once: true,
        disable: function () {
            return window.innerWidth < 992;
        },
    });
}, []);

return(
<div className="page-content servicepage">
    <section className="wi_full py_3 inner_banner" style={{backgroundImage: "url('./images/service-banner.jpg')",backgroundSize: "cover",
        backgroundPosition: "center", backgroundRepeat: "no-repeat",}}>
        <div className="container" data-aos="fade-in">
            <h1>What we offer</h1>
        </div>
    </section>
    <Offer />
    <Partner />
</div>
)
}